import styled from 'styled-components';

import {getColor, getRem, gts, ms} from '@yourcoach/shared/styles';
import {Text} from '@yourcoach/shared/uikit/Text';
import {View} from '@yourcoach/shared/uikit/View';

export const Container = styled(View)`
  flex-direction: column;
`;

export const IFrame = styled.iframe`
  border: 0;
  min-height: calc(60vh - 40px);
`;

export const Footer = styled(View)`
  flex-direction: column;
  padding-block-start: ${gts('padding.me')};
  width: 100%;
`;

export const SignatureContainer = styled(View)`
  flex-direction: column;
  gap: ${gts('gap.me')};
`;

export const SignatureHeader = styled(Text).attrs({
  variant: 'h3',
  weight: 'bold',
})``;

export const SignatureHolder = styled(View)`
  flex-direction: column;
  gap: ${gts('gap.me')};
  padding-block-start: ${gts('padding.la')};
`;

export const SignatureLine = styled(View)`
  height: 1px;
  background-color: ${getColor('border.middle')};
`;

export const Signature = styled(Text)`
  font-family: 'Mr De Haviland', cursive;
  font-size: ${getRem(50)};
  position: relative;
  left: ${ms(15)};
`;

export const SignatureName = styled(Text)``;

export const SignatureDate = styled(Text)`
  color: ${getColor('text.gray')};
`;
